// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"c514afef","72":"d819bde0","258":"d819bde0","388":"c514afef","586":"d819bde0"}[chunkId] + ".css";
};